import { DialogProps } from "@mitratech/north-star";
import { NSAction } from "../../../../../../packages/north-star/src/library/types/interfaces";

export enum CaseAction {
  Open = "open",
  Close = "close",
  Cancel = "cancel",
  ChangeOwner = "change-owner",
}

export interface CaseActionConfirmState extends Omit<DialogProps, "onAction" | "onClose" | "children"> {
  /**
   * ID of the case we are acting on */
  caseId?: string;

  /**
   * The action name we are performing on the caseId */
  command?: CaseAction;

  /**
   * Actions appear as Buttons */
  actions: NSAction[];
}
